window.jQuery = window.$ = require('jquery');
window.bootstrap = require('bootstrap');
window.Popper = require('@popperjs/core');
window.wNumb = require('wnumb');
window.moment = require('moment');

require("es6-shim/es6-shim.min.js");

require('bootstrap-daterangepicker/daterangepicker.js');
require('bootstrap-maxlength/src/bootstrap-maxlength.js');
require('bootstrap-multiselectsplitter/bootstrap-multiselectsplitter.min.js');

require('select2/dist/js/select2.full.min.js');
require('../metronic/js/vendors/plugins/select2.init.js');

window.tempusDominus = require('@eonasdan/tempus-dominus/dist/js/tempus-dominus.min.js');
require('@eonasdan/tempus-dominus/dist/plugins/customDateFormat.js');
require('../metronic/js/vendors/plugins/tempus-dominus.init.js');

require('flatpickr/dist/flatpickr.js');
require('flatpickr/dist/l10n/ar.js');

require('inputmask/dist/inputmask.js');
require('inputmask/dist/bindings/inputmask.binding.js');

require('jquery-validation');
require('jquery-validation/dist/localization/messages_id');
require('jquery-validation/dist/additional-methods');

window.noUiSlider = require('nouislider/dist/nouislider.min.js');

window.autosize = require('autosize/dist/autosize.min.js');

window.ClipboardJS = require('clipboard/dist/clipboard.min.js');

window.Quill = require('quill/dist/quill.js');

require('@yaireo/tagify/dist/tagify.polyfills.min.js');
window.Tagify = require('@yaireo/tagify/dist/tagify.min.js');

window.toastr = require('../metronic/plugins/toastr/build/toastr.min.js');

require('es6-promise-polyfill/promise.min.js');

window.Swal = window.swal = require('sweetalert2/dist/sweetalert2.min.js');
require('../metronic/js/vendors/plugins/sweetalert2.init.js');

window.tns = require('tiny-slider/src/tiny-slider.js').tns;
window.SmoothScroll = require('smooth-scroll/dist/smooth-scroll.js');
window.lozad = require('lozad/dist/lozad.min.js');
